import { BacnetServicesSupportedList } from "../../../components/BacnetServicesSupportedList";
import { IBacnetDevice } from "./types";

const InsightsPanel = (props: IBacnetDevice) => {

    return (<>
        <BacnetServicesSupportedList servicesSupported={props.servicesSupported}></BacnetServicesSupportedList>
    </>)
}

export default InsightsPanel